/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const TabMenuBottom = (props) => {
    const classNames = [
        'c-tab-menu__bottom',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TabMenuBottom.propTypes = propTypes;

TabMenuBottom.defaultProps = defaultProps;

export default TabMenuBottom;
